// extracted by mini-css-extract-plugin
export default {"button":"CartButton_button__wqA4z","cart":"CartButton_cart__jGsQI","badge":"CartButton_badge__NiZqj"};